<script>
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

export default {
  setup() {
    // const { t } = useI18n();
    // const route = useRoute();

    // useHeadMeta({
    //   title: t("membership.meta.title"),
    //   description: t("membership.meta.description"),
    //   url: route.fullPath,
    //   image: "https://www.opero.cz/img/2_o_nas.jpg",
    //   alt: "Opero",
    // });
  },
  data() {
    return {
      imageList: [
        "Opero_coworking_byznys_hub_clenstvi_praha",
        "/img/Opero_coworking_atraktivni_prostredi_byznys_podnikatel.jpg",
        "/img/Opero_networking_propojovani_kontakty_clenstvi.jpg",
        "/img/Opero_sluzby_clenstvi_profesionalni_coworking_Praha1.jpg",
        "/img/Opero_cowork_pracovni_zazemi_v_centru_Prahy.jpg",
        "/img/Opero_misto_pro_dulezita_jednani_s_klienty_praha.jpg",
        "/img/Opero_byznys_profesionalni_pratelsky_networking.jpg",
        "/img/Networking_Opero_community_coworking.jpg",
        "/img/Coworking_business_hub_network_connections_Prague1.jpg",
      ],
      currentImage: 0,
      cursor: "",
      cursorStyle: {},
      width: 1365,
      xTo: null,
      yTo: null,
      loading: false,
    };
  },
  computed: {
    getHeight() {
      if (this.width > 1350) return 970;
      if (this.width > 1150) return this.width - 410;
      return this.width - 360;
    },
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    window.document.removeEventListener("click", this.cursorOnClick);
  },
  mounted() {
    const images = Array.from(document.querySelectorAll("img")); // Select all images
    const videos = Array.from(document.querySelectorAll("video")); // Select all videos
    const mediaElements = [...images, ...videos];

    const loadPromises = mediaElements.map(
      (element) =>
        new Promise((resolve) => {
          if (element.complete || element.readyState > 0) {
            resolve(null);
          } else {
            element.addEventListener("load", () => resolve(null), {
              once: true,
            });
          }
        })
    );

    Promise.all(loadPromises).then(() => {
      this.loading = false;
    });

    window.addEventListener("scroll", this.handleScroll);

    window.addEventListener("resize", this.handleResize);

    this.width =
      document.body.clientWidth ||
      window.innerWidth ||
      document.documentElement.clientWidth;
    if (this.width > 1024) {
      gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

      this.xTo = gsap.quickTo("#cursor", "x", {
        duration: 0.1,
        ease: "power3",
      });
      this.yTo = gsap.quickTo("#cursor", "y", {
        duration: 0.1,
        ease: "power3",
      });
    }
    // this.applyAnimations();
  },
  methods: {
		onClick(location) {
			gsap.registerPlugin(ScrollToPlugin);
			gsap.to(window, { duration: 1, scrollTo: location });
		},
    changeTestimonial(t) {
      this.currentImage = t;
    },
    changeTestimonial2(t) {
      this.currentImage2 = t;
    },
    setCursor(value, onClick, style) {
      this.cursor = value;
      if (this.cursorOnClick !== onClick) {
        window.document.removeEventListener("click", this.cursorOnClick);
        this.cursorOnClick = onClick;

        window.document.addEventListener("click", this.cursorOnClick, {
          name: "membership" + value,
        });
      }
      if (this.cursorStyle !== style) {
        this.cursorStyle = style;
      }
    },
    cursorOnClick: () => {},
    mouseMove(e) {
      if (this.width > 1024) {
        // this.xTo = e.pageX;
        // this.yTo = e.pageY;
        //
        this.xTo(e.pageX);
        this.yTo(e.pageY);
      }
    },
    handleScroll() {},
    handleResize() {
      this.width =
        document?.body?.clientWidth ||
        window?.innerWidth ||
        document?.documentElement?.clientWidth;
      if (this.width > 1024) {
        gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

        this.xTo = gsap.quickTo("#cursor", "x", {
          duration: 0.1,
          ease: "power3",
        });
        this.yTo = gsap.quickTo("#cursor", "y", {
          duration: 0.1,
          ease: "power3",
        });
      }
    },
  },
};

</script>

<script setup>
  const { locale, t } = useI18n();
  const route = useRoute();
  const config = useRuntimeConfig()
  const includeCategories = config.public.MEMBERSHIP_ARTICLE_CATEGORIES.split(',');
  // const includeCategories = [287,289,297,291,293,295];

  useHeadMeta({
    title: t("membership.meta.title"),
    description: t("membership.meta.description"),
    url: route.fullPath,
    csUrl: 'cs/clenstvi',
    enUrl: 'en/membership',
    image: "https://www.opero.cz/img/2_o_nas.jpg",
    alt: "Opero",
  });

const query = gql`
  query CustomPosts {
    categories(where: {include: [${includeCategories.join(',')}], language: ${locale.value.toString().toUpperCase()}}) {
      edges {
        node {
          id
          name
          parentId
          categoryConfig {
            order
          }
          posts {
            edges {
              node {
                id
                title

                date
                slug
                tags {
                  nodes {
                    name
                  }
                }
                featuredImage {
                  node {
                    id
                    mediaItemUrl
                  }
                }
                blogConfig {
                  perex
                  content
                }
              }
            }
          }
        }
      }
    }
  }
 
`;

const variables = { limit: 5 };
const { data } = await useAsyncQuery(query, variables);

const categories = computed(() => {
  const edges = data.value?.categories?.edges ?? [];
  const nodes = edges.map(edge => edge.node);

  return nodes.sort(
    (a, b) => (a.categoryConfig?.order ?? 0) - (b.categoryConfig?.order ?? 0)
  );
});

onMounted(() => {

})
</script>

<template>
  <div @mousemove="mouseMove">
    <div class="overflow-hidden">
      <div class="navbar-wrapper">
        <Navbar
          :is-dark="true"
          @mouseover="
            setCursor(null, null, {
              'font-size': '14px',
              cursor: 'unset',
              'z-index': '1',
              width: '25px',
              height: '25px',
              opacity: 0.7,
            })
          "
        />
      </div>

      <div class="lg:relative">
        <Bubbles
          v-if="width > 1024"
          :key="width"
          class="w-full !absolute top-0"
          :height="getHeight"
          :start-width="700"
          :set-cursor="setCursor"
          ref-prop="canvasMembership"
        />
        <div class="w-full pt-28 lg:pt-32 pointer-events-none">
          <div class="flex justify-start lg:justify-center pointer-events-none">
            <div
              class="w-[1280px] max-w-7xl pointer-events-none relative overflow-hidden"
            >
              <AnimateTitle
                class="mb-12 lg:mb-24 sm:px-6 pointer-events-none"
                :title="$t('membership.title')"
              />

              <ImageCarousel
                id="firstSpaces"
                :set-cursor="setCursor"
                class="pointer-events-auto"
                :images="imageList"
                :current-image="currentImage"
                :change-testimonial="changeTestimonial"
              />
              <div class="flex justify-center pointer-events-auto mt-6">
                <BubblesNavigationPaper
                  :height="50"
                  :width="35 * imageList.length"
                  start-width="50"
                  :testimonials="imageList"
                  :change-testimonial="changeTestimonial"
                  :current-selected="currentImage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-10">
        <div class="flex justify-center">
          <div class="max-w-7xl p-6 w-full">
            <AnimatePerex :title="$t('membership.perex')" />
          </div>
        </div>
      </div>
      <WhatIsOperoClub
        :set-cursor="setCursor"
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      />
      <template v-if="false">
			<div class="container mx-auto" @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        ">
				<div class="grid grid-cols-12 xl:gap-8 mb-10 xl:mb-14">
					<div class="col-span-12 xl:col-span-10 xl:col-start-2">
						<div class="flex justify-center lg:mt-12 p-6 lg:p-0">
							<div>
								<button class="!normal-case nav-button" @click="onClick('#coworking')">
									{{ $t("membership.buttons.coworking") }}
								</button>
								<button class="!normal-case nav-button" @click="onClick('#opero-club')">
									{{ $t("membership.buttons.membership") }}
								</button>
								<button class="!normal-case nav-button" @click="onClick('#office-rental')">
									{{ $t("membership.buttons.office") }}
								</button>
								<button class="!normal-case nav-button" @click="onClick('#registered-office')">
									{{ $t("membership.buttons.company") }}
								</button>
								<button class="!normal-case nav-button" @click="onClick('#day-pass')">
									{{ $t("membership.buttons.day-pass") }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<CoworkingMembership id="coworking" :set-cursor="setCursor" />
      </template>

			<ClubMembership id="opero-club" :set-cursor="setCursor" />

      <div class="membership-posts flex justify-center pt-16 p-8 md:p-16">
        <div class="max-w-7xl w-full" v-if="categories.length">
          <h2 class="h1">{{ $t('membership.posts.title') }}</h2>
          <template
            v-for="(category, i) in categories"
            :key="category?.id || i"
          >
            <div
              class="membership-post-category"
              v-if="category?.posts?.edges.length"
            >
              <ClubMembershipProjects
                :category="category"
                :set-cursor="setCursor"
                :class="{ 'mt-10 md:mt-0': i !== 0 }"
              />
            </div>
          </template>
        </div>
      </div>

      <HowItWorks :set-cursor="setCursor" />

      <div
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      >
        <div class="flex justify-center">
          <div
            class="max-w-7xl md:text-center px-6 pt-12 lg:pt-24 pb-12 lg:pb-24 w-full"
          >
            <h2 class="h1">{{ $t("membership.moreServices.title") }}</h2>
          </div>
        </div>
      </div>

      <div
        class="flex justify-center px-6 mt-16 md:mt-12"
				id="cowork"
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      >
        <div class="max-w-7xl lg:grid grid-cols-2 w-full" id="company2">
          <div class="self-center">
            <NuxtImg
              class="w-full w-auto"
              src="/img/membership-cowork.webp"
              alt=""
              sizes="640px"
            />
          </div>
          <div class="p-0 pt-6 md:px-12">
            <div>
              <div class="">
                <h3>{{ $t("membership.moreServices.cowork.title") }}</h3>
              </div>
              <div class="mt-4">
                <p>
                  <span class="font-semibold text-lg">
                    <span>{{ $t("membership.moreServices.pricePrefix") }} + </span>
										<span v-if="$i18n.locale !== 'cs'">CZK</span> 2{{
											$i18n.locale === "cs" ? " " : ","
										}}500 <span class="font-semibold" v-if="$i18n.locale === 'cs'">Kč</span>/{{ $t("membership.moreServices.month") }}
									</span>
									<span class="block mt-2.5 text-xs" v-html="$t('membership.price-note-header')" />
                </p>
              </div>

              <div class="mt-4">
                {{ $t("membership.moreServices.cowork.description") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex justify-center px-6 mt-16 md:mt-12"
				id="desk"
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      >
        <div class="max-w-7xl lg:grid grid-cols-2 w-full" id="company2">
          <div class="self-center">
            <NuxtImg
              class="w-full w-auto"
              src="/img/membership-desk.webp"
              alt=""
              sizes="640px"
            />
          </div>
          <div class="p-0 pt-6 md:px-12">
            <div>
              <div class="">
                <h3>{{ $t("membership.moreServices.desk.title") }}</h3>
              </div>
              <div class="mt-4">
                <p>
                  <span class="font-semibold text-lg">
                    <span>{{ $t("membership.moreServices.pricePrefix") }} + </span>
										<span v-if="$i18n.locale !== 'cs'">CZK</span> 6{{
											$i18n.locale === "cs" ? " " : ","
										}}000 <span class="font-semibold" v-if="$i18n.locale === 'cs'">Kč</span>/{{ $t("membership.moreServices.month") }}
									</span>
									<span class="block mt-2.5 text-xs" v-html="$t('membership.price-note-header')" />
                </p>
              </div>

              <div class="mt-4">
                {{ $t("membership.moreServices.desk.description") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex justify-center px-6 mt-16 md:mt-12"
				id="office-rental"
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      >
        <div class="max-w-7xl lg:grid grid-cols-2 w-full" id="office">
          <div class="self-center">
            <NuxtImg
              class="w-full w-auto"
              src="/img/membership-office.jpg"
              alt=""
              format="webp"
              loading="lazy"
              sizes="640px"
            />
          </div>
          <div class="p-0 pt-6 md:px-12">
            <div>
              <div v-if="false" class="flex">
                <img class="h-6 mr-3" src="../assets/icon-infinite.png" />
                <div>
                  2 - 8 {{ $t("membership.moreServices.membersIncluded") }}
                </div>
              </div>
              <div>
                <h3>{{ $t("membership.moreServices.office.title") }}</h3>
              </div>
              <div class="mt-4">
                <p>
									<span class="font-semibold text-lg">
										{{ $t("membership.moreServices.from") }}
										<span v-if="$i18n.locale !== 'cs'">CZK</span> 38{{
											$i18n.locale === "cs" ? " " : ","
										}}000 <span class="font-semibold" v-if="$i18n.locale === 'cs'">Kč</span>/{{ $t("membership.moreServices.month") }}
									</span>
									<span class="block mt-2.5 text-xs" v-html="$t('membership.price-note-header')" />
                </p>
              </div>
              <div class="text-t mt-4">
                <b>
                  {{ $t("membership.moreServices.office.subtitle") }}
                </b>
              </div>
              <div class="mt-4">
                {{ $t("membership.moreServices.office.description") }}
              </div>
              <div v-if="$i18n.locale === 'cs'" class="mt-6">
                <button
                  class="bg-transparent border border-black rounded-full px-3 py-1 font-normal nav-btns pointer-events-auto !font-normal"
                  @click="
                    navigateTo({
                      path: localePath({
                        name: 'article-id',
                        params: { id: 'volne-kancelare' },
                      }),
                    })
                  "
                >
                  {{ $t("check-if-available") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex justify-center px-6 mt-16 md:mt-12"
				id="registered-office"
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      >
        <div class="max-w-7xl lg:grid grid-cols-2 w-full" id="company">
          <div class="self-center">
            <NuxtImg
              class="w-full w-auto"
              src="/img/membership-hq.jpg"
              alt=""
              sizes="640px"
            />
          </div>
          <div class="p-0 pt-6 md:px-12">
            <div>
              <div class="">
                <h3>{{ $t("membership.moreServices.headqaurters.title") }}</h3>
              </div>
              <div class="mt-4">
                <p>
                  <span class="font-semibold text-lg">
                    <span>{{ $t("membership.moreServices.pricePrefix") }} + </span>
										<span v-if="$i18n.locale !== 'cs'">CZK</span> 1{{
											$i18n.locale === "cs" ? " " : ","
										}}500 <span class="font-semibold" v-if="$i18n.locale === 'cs'">Kč</span>/{{ $t("membership.moreServices.month") }}
									</span>
									<span class="block mt-2.5 text-xs" v-html="$t('membership.price-note-header')" />
                </p>
              </div>

              <div class="mt-4">
                {{ $t("membership.moreServices.headqaurters.description") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="false"
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      >
        <div class="flex justify-center px-6 pt-12 lg:pt-24 pb-12 lg:pb-24">
          <div class="max-w-7xl md:text-center w-full">
            <h2 class="h1">{{ $t("membership.moreServices.isYourStay") }}</h2>
          </div>
        </div>
      </div>

      <div
        class="flex justify-center px-6 mb-16 mt-16 md:mt-12"
				id="day-pass"
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      >
        <div class="max-w-7xl lg:grid grid-cols-2 w-full" id="day-pass">
          <div class="self-center">
            <NuxtImg
              class="w-full w-auto"
              src="/img/membership-daypass.jpg"
              alt=""
              format="webp"
              loading="lazy"
              sizes="640px"
            />
          </div>
          <div class="p-0 pt-6 md:px-12">
            <div>
              <div v-if="false" class="lg:flex">
                <img class="h-6 mr-3" src="../assets/icon-infinite.png" />
              </div>
              <div>
                <h3>{{ $t("membership.moreServices.dayPass.title") }}</h3>
              </div>
              <div class="mt-4">
                <p>
									<span class="text-lg font-semibold">
										<span v-if="$i18n.locale !== 'cs'">CZK</span> 1{{
											$i18n.locale === "cs" ? " " : ","
										}}000 <span class="font-semibold" v-if="$i18n.locale === 'cs'">Kč</span>/{{ $t("membership.moreServices.day") }}
									</span>
									<span class="block mt-2.5 text-xs" v-html="$t('membership.price-note-header2')" />
                </p>
              </div>
              <div class="text-t mt-4">
                {{ $t("membership.moreServices.dayPass.subtitle") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="false"
        class="md:relative pointer-events-auto pb-0 lg:pb-20 xl:pb-0"
        @mouseover="
          setCursor(null, null, {
            'font-size': '14px',
            cursor: 'unset',
            'z-index': '-1',
            width: '25px',
            height: '25px',
          })
        "
      >
        <Bubbles
          v-if="width > 1024"
          :key="width"
          :height="getHeight"
          :start-width="900"
          :set-cursor="setCursor"
          ref-prop="secondCanvasRef"
        />
        <!-- <Bubbles
          v-if="width > 1024"
          key="qwdwef"
          :height="900"
          :start-width="900"
          ref-prop="secondCanvasRef"
          :set-cursor="setCursor"
        /> -->

        <div
          class="lg:absolute md:top-12 w-full flex justify-center mb-16 md:mb-0"
        >
          <div class="max-w-7xl md:grid grid-cols-2 gap-12">
            <div class="">
              <div class="p-6 md:p-6 md:pt-12">
                <div
                  class="text-[36px] leading-[1.25] font-light mb-6 md:mb-10"
                >
                  {{ $t("membership.discoverMore.title.part1") }} <br />
                  {{ $t("membership.discoverMore.title.part2") }}
                </div>
                <p class="md:txt-q md:mb-12">
                  {{ $t("membership.discoverMore.subtitle") }}
                </p>
                <div
                  class="flex justify-center md:hidden p-12 py-6 md:py-0 md:p-0 pointer-events-none"
                >
                  <NuxtImg
                    src="/img/Kontakt_Karolina_skodova.jpg"
                    class="membership-contact"
                    sizes="725px"
                  />
                </div>
                <div
                  class="txt-q md:mb-2 text-center md:text-left pointer-events-none"
                >
                  {{ $t("membership.discoverMore.name") }}
                </div>
                <div class="txt-t text-center md:text-left pointer-events-none">
                  {{ $t("membership.discoverMore.position") }}
                </div>
                <div class="flex justify-center md:justify-normal">
                  <button
                    class="bg-transparent border border-black rounded-full px-3 py-1 font-normal nav-btns mt-6 md:mt-12 pointer-events-auto !font-normal"
                    @click="
                      navigateTo({
                        path: localePath({ name: 'contact' }),
                        query: { from: 'membership' },
                      })
                    "
                  >
                    {{ $t("membership.discoverMore.button") }}
                  </button>
                </div>
              </div>
            </div>
            <div
              class="hidden md:block overflow-hidden xl:overflow-visible p-12 md:p-0 pointer-events-none"
            >
              <NuxtImg
                src="/img/Kontakt_Karolina_skodova.jpg"
                class="membership-contact"
                sizes="640px"
                format="webp"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <JoinUsMembership v-if="false" :set-cursor="setCursor" />

      <Footer :set-cursor="setCursor" />
      <div
        id="cursor"
        class="hidden cursor-auto lg:cursor-none lg:flex pointer-events-none"
        :style="cursorStyle"
        :class="{
          smallCursor: cursor === null,
        }"
        @click="cursorOnClick"
        v-html="cursor"
      ></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.carousel-container {
  @media screen and (min-width: 1280px) {
    padding: 0px 0px !important;
  }
}
.bg-brand {
  background-color: $color-primary;
}

.h2-ngap {
  //background-color: #1A1A1A;
  margin-top: -10px;
  @media screen and (max-width: 1024px) {
    margin-top: -6px;
  }
}

.membership-posts {
  border-top: solid 1px #000;
}

.membership-contact {
  height: 725px;
  width: 725px;
  max-width: unset;
  border-radius: 100%;

  @media screen and (max-width: 1024px) {
    height: 500px;
    width: 500px;
  }

  @media screen and (max-width: 768px) {
    height: 100%;
    width: 100%;
    max-width: 350px;
    max-height: 350px;
  }
}

#cursor {
  position: absolute;
  top: 0;
  left: -10px;
  width: 25px;
  height: 25px;
  display: none;
  font-weight: 400;

  justify-content: center;
  align-items: center;
  background-color: $color-primary;
  border-radius: 50%;
  z-index: 1000;
  cursor: none;
  transition:
    width 0.3s,
    height 0.3s,
    background-color 0.3s;
  transform: translate(-50%, -50%) translate(-150px, -150px);
  //pointer-events: none;
  text-align: center;
  @media screen {
    @media (pointer: fine) {
      display: flex;
    }
  }
}

.smallCursor {
  width: 20px;
  height: 20px;
  background-color: $color-primary;
}

.nav-button {
  border-radius: 0;
  background: black;
  color: white;
  margin: 4px;
  padding: 10px;
  font-weight: 300;
  font-size: 26px;
  transition:
    background-color 0.4s,
    color 0.4s;

  &:hover {
    background-color: $color-primary;
    color: black;
  }
}
</style>
